import React from 'react';
import TableHead from "@material-ui/core/TableHead";
import TableBody from "@material-ui/core/TableBody";
import Table from "@material-ui/core/Table";
import TableLine from "./TableLine";
import {Paper} from "@material-ui/core";

class Lashes extends React.Component {

    new_fs = 'New FS';

    list = {
        lashes: {
            head: ['Non-Members', 'Full-set', '1 Week Touch-Up', '2 Weeks RF', '3 Weeks RF', '4+ Weeks RF'],
            classic: ['Classic Look', 200, 100, 130, 165,  this.new_fs],
            mega_classic: ['Mega Classic', 200, 100, 130, 165,  this.new_fs],
            hybrid: ['Hybrid Wispy', 265, 115, 150, 200,  this.new_fs],
            l_volume: ['Light Volume', 285, 120, 150, 210,  this.new_fs],
            volume: ['Volume Drama', 300, 130, 170, 230,  this.new_fs],
            mega_volume: ['Mega Volume', 365, 150, 200, 260, this.new_fs],
            lash_lift: ['Lash Lift & Tint', 150, '', '',  '']
        },
        lashes_members : {
            head: ['Membership', 'Description', '1RF/mo'],
            classic: ['Mega Classic', 'One Mega Classic Refill /mo', 99.99],
            hybrid: ['Hybrid / Light Volume', 'One Hybrid OR Light Volume Refill /mo', 125],
            volume: ['Volume Drama', 'One Volume Drama Refill /mo', 149.99],
            mega_volume: ['Mega Volume', 'One Mega Volume Refill /mo', 185]
        }
    };

    render() {
        return(
            <div>
                <Paper className='mx-3 mt-1 mb-3'>
                    <Table>
                        <TableHead>
                            <TableLine list={this.list.lashes.head} head={true} />
                        </TableHead>
                        <TableBody>
                            <TableLine list={this.list.lashes.classic} head={false} />
                            <TableLine list={this.list.lashes.mega_classic} head={false} />
                            <TableLine list={this.list.lashes.hybrid} head={false} />
                            <TableLine list={this.list.lashes.l_volume} head={false} />
                            <TableLine list={this.list.lashes.volume} head={false} />
                            <TableLine list={this.list.lashes.mega_volume} head={false} />
                            <TableLine list={this.list.lashes.lash_lift} head={false} />
                        </TableBody>
                    </Table>
                </Paper>
                <Paper className='mx-3 mt-1 mb-3'>
                    <Table>
                        <TableHead>
                            <TableLine list={this.list.lashes_members.head} head={true} membership={true}/>
                        </TableHead>
                        <TableBody>
                            <TableLine list={this.list.lashes_members.classic} head={false} />
                            <TableLine list={this.list.lashes_members.hybrid} head={false} />
                            <TableLine list={this.list.lashes_members.volume} head={false} />
                            <TableLine list={this.list.lashes_members.mega_volume} head={false} />
                        </TableBody>
                    </Table>
                </Paper>
            </div>
        )
    }
}

export default Lashes;
